import { SET_REPORT_SECTION_TAB_VALUE } from './types';

export function setReportSectionTabValue(tabValue: number) {
  return {
    type: SET_REPORT_SECTION_TAB_VALUE,
    payload: tabValue,
  };
}
